import {createCheckoutT, postSubmitErrorKey} from '@it-s-ai/auth';
import {observedLanguage, translate} from 'i18n/translator';
import type {LocalizedText} from 'i18n/text';

type BillingAction = 'checkout' | 'details' | 'portal' | 'claim' | 'activation' | 'method' | 'autopay';

/** Keep server/Stripe diagnostics in logs, and resolve customer copy in the current locale. */
export function billingErrorText(error: unknown, action: BillingAction): LocalizedText {
    const failure = error as {code?: string; response?: {status?: number; data?: {error?: {code?: string}}}} | null;
    const status = failure?.response?.status;
    const rawCode = status === 401 ? 'authentication_failed'
        : status === 429 ? 'rate_limit'
        : failure?.response?.data?.error?.code || failure?.code;
    const code = typeof rawCode === 'string' ? rawCode : undefined;
    // These operations may follow a successful charge; their failure does not
    // establish a card decline, and must not invite a second purchase.
    const key = action === 'activation' || action === 'claim'
        ? 'checkout-toast-temporary'
        : postSubmitErrorKey({code: ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT'].includes(code || '') ? 'network_error' : code});
    return () => {
        const text = createCheckoutT(observedLanguage() || 'en')(key);
        // Older auth versions may not know a newly added key yet.
        return key !== 'checkout-toast-temporary' && text !== key
            ? text : translate(`billing-error-${action}`);
    };
}
